var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/profile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "secondarytint",
    d: "M13.5 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 1 0 0-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.161 22c1.65 0 2.8-1.85 2.2-3.6-1.25-3.75-4.4-6.4-8.1-6.4-3.7 0-6.85 2.65-8.1 6.4-.6 1.75.55 3.6 2.2 3.6h11.8z",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.65 11c2.6-.05 4.8-2.25 4.85-4.85.1-2.85-2.2-5.15-5-5.15-2.75 0-5 2.25-5 5 0 2.8 2.3 5.1 5.15 5zm-.15-9c2.2 0 4 1.8 4 4 0 2.45-2.25 4.4-4.8 3.9-1.55-.3-2.8-1.55-3.1-3.1C7.1 4.25 9.05 2 11.5 2zM21 21.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5c0-4.7-3.8-8.5-8.5-8.5S3 16.8 3 21.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5c0-5.25 4.25-9.5 9.5-9.5s9.5 4.25 9.5 9.5z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.25d9391012254dda6d1fac2dc1a750f2.svg";
export { ForwardRef as ReactComponent };